/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nudge_Ask_Meeting_Feedback_ActionInputs */



/**
* | output |
* | --- |
* | "Ask for feedback" |
*
* @param {Nudge_Ask_Meeting_Feedback_ActionInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const nudge_ask_meeting_feedback_action = /** @type {((inputs?: Nudge_Ask_Meeting_Feedback_ActionInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nudge_Ask_Meeting_Feedback_ActionInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Vraag feedback")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Demander un retour")
	return /** @type {LocalizedString} */ ("Ask for feedback")
});